import { render, staticRenderFns } from "./list.vue?vue&type=template&id=16442b87&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\works\\private\\kurlakk\\site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16442b87')) {
      api.createRecord('16442b87', component.options)
    } else {
      api.reload('16442b87', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=16442b87&", function () {
      api.rerender('16442b87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/web/vue/views/properties/list.vue"
export default component.exports